import React, { useState, Fragment, useEffect, useRef } from "react";
import { Table, Row, Col, Card, CardBody } from "reactstrap";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useVirtualizer } from '@tanstack/react-virtual';

const TableContainerSearch2 = ({
  footer,
  summary,
  columns,
  data,
  theadClass = "",
  tbodyClass = "",
  globalFilter,
  setGlobalFilter
}) => {
  
  const [summaryData, setSummarydata] = useState(summary);

  // React-Table setup
  // const table = useReactTable({
  //   columns,
  //   data,
  //   getCoreRowModel: getCoreRowModel(),
  //   getSortedRowModel: getSortedRowModel(),
  //   getFilteredRowModel: getFilteredRowModel(),
  //   globalFilterFn: (row, columnId, filterValue) => {
  //     return String(row.getValue(columnId))
  //       .toLowerCase()
  //       .includes(filterValue.toLowerCase());
  //   },
  // });
  const [sorting, setSorting] = useState([]); // Added sorting state

  // React-Table setup
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      globalFilter,
      sorting, // Use sorting state
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting, // Update sorting state
  });

  const {
    getHeaderGroups,
    getRowModel,
    getCanPreviousPage,
    getCanNextPage,
    getPageOptions,
    setPageIndex,
    nextPage,
    previousPage,
    setPageSize,
    getState,
  } = table;

  // console.log("table data",getRowModel().rows)

  useEffect(() => {
    const totals = getRowModel()?.rows.reduce(
      (acc, item) => {
        acc.total_buy_qty += +item?.original.buy_qty || 0;
        acc.total_buy_value += +item?.original.buy_value || 0;
        acc.total_sell_qty += +item?.original.sell_qty || 0;
        acc.total_sell_value += +item?.original.sell_value || 0;
        acc.total_net_qty += +item?.original.net_qty || 0;
        acc.total_net_value += +item?.original.net_value || 0;
        acc.total_pnl += +item?.original.pnl || 0;

        return acc;
      },
      {
        total_buy_qty: 0,
        total_buy_value: 0,
        total_sell_qty: 0,
        total_sell_value: 0,
        total_net_qty: 0,
        total_net_value: 0,
        total_pnl: 0,
        start: summary?.start,
        end: summary?.end,
      }
    );
    // console.log("total", totals);
    // console.log("data", getRowModel().rows)
    setSummarydata(totals);
  }, [getRowModel, globalFilter]);

  const tableContainerRef = useRef(null);
  
  const rows = table.getRowModel().rows;

  // Virtual row configuration
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => 45, // Estimated row height in pixels
    overscan: 10, // Number of items to render outside visible area
  });

  const virtualRows = rowVirtualizer.getVirtualItems();
  const totalSize = rowVirtualizer.getTotalSize();

  const paddingTop = virtualRows.length > 0 ? virtualRows[0].start : 0;
  const paddingBottom = virtualRows.length > 0 
    ? totalSize - virtualRows[virtualRows.length - 1].end 
    : 0;

  const isNumeric = (value) => {
    if (typeof value === "number") return true;
    if (typeof value === "string") {
      // Remove commas (if any) before checking.
      return !isNaN(Number(value.replace(/,/g, "")));
    }
    return false;
  };

  return (
    <Fragment>
      {/* Search Input */}
      <Row className="">
        {/* <Col lg={12} md={12} xs={12}> */}
        {/* <div class="search-box d-inline-block col-xxl-3 col-xl-4 col-lg-7 col-12">
          <input
            id="search-bar-0"
            type="text"
            style={{
              backgroundColor: "#F1F4F7",
              border: "1px solid transparent",
            }}
            className="form-control border-0 search"
            placeholder="Search by instrument"
            value={globalFilter}
            onChange={(e) => {
              setGlobalFilter(e.target.value);

            
            }}
          />

         
          <i class="bx bx-search-alt search-icon"></i>
        </div> */}
        {/* </Col> */}
      </Row>

      {/* Table Container */}
      <div 
      ref={tableContainerRef}
      style={{
        maxHeight: '70vh', 
        overflow: 'auto',
        position: 'relative'
      }}
      className="table-responsive table-container"
    >
        <table hover className="table table-hover align-middle table-nowrap table-bordered">
        <thead 
            className={`bg-gl-primary sticky-header ${theadClass}`}
            style={{
              position: 'sticky',
              top: -1,
              zIndex: 2,
              background: 'inherit'
            }}
          >
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  const isSorted = header.column.getIsSorted();
                  // console.log("header", header, headerGroup);
                  return (
                    <th
                      key={header.id}
                      style={{
                        textAlign: header.column.columnDef.headerTextAlign,
                        cursor: "pointer",
                        whiteSpace: "normal", 
                        padding:"0.3rem",
                        paddingLeft:"0.4rem"
                      }}
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        {flexRender(
                          header.column.columnDef.Header,
                          header.getContext()
                        )}
                        {isSorted === "asc" ? (
                          <i className="ms-2 bx bx-caret-up"></i>
                        ) : isSorted === "desc" ? (
                          <i className="ms-2 bx bx-caret-down"></i>
                        ) : (
                          <i className="ms-2 bx bxs-sort-alt"></i>
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody className={tbodyClass}>
          {data?.length > 0 ? (
            rows.length > 0 ? (
              <>
                {paddingTop > 0 && (
                  <tr>
                    <td colSpan={columns?.length} style={{ height: `${paddingTop}px` }} />
                  </tr>
                )}
                {virtualRows.map((virtualRow) => {
                  const row = rows[virtualRow.index];
                  return (
                    <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => {
                    const rawValue = cell.getValue();
                    let renderedContent = flexRender(cell.column.columnDef.cell, cell.getContext());
                
                    // Utility function to check for numeric values.
                    const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);
                
                    // If the cell is not in the "pnl" column and the raw value is numeric,
                    // format the number to always show two decimals.
                    if (cell.column.id !== "pnl" && isNumeric(rawValue)) {
                      const numericValue = Number(String(rawValue).replace(/,/g, ""));
                      renderedContent = numericValue.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      });
                    }
                
                    return (
                      <td
                        key={cell.id}
                        className="fs-p-bg fw-medium"
                        style={{
                          textAlign: cell.column.columnDef.bodyTextAlign,
                          whiteSpace: "normal",
                          padding: "0.3rem",
                          paddingLeft: "0.4rem"
                        }}
                      >
                        {renderedContent}
                      </td>
                    );
                  })}
                </tr>
                );
              })}
              {paddingBottom > 0 && (
                <tr>
                  <td colSpan={columns?.length} style={{ height: `${paddingBottom}px` }} />
                </tr>
              )}
            </>
              ) : (
                <tr>
                  <td
                    colSpan={columns?.length}
                    className="p-1"
                    style={{ textAlign: "center" }}
                  >
                    <Card className="m-0 text-muted">
                      <CardBody>No Record Found</CardBody>
                    </Card>
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td
                  colSpan={columns?.length}
                  className="p-1"
                  style={{ textAlign: "center" }}
                >
                  <Card className="m-0 text-muted">
                    <CardBody>No Record Found</CardBody>
                  </Card>
                </td>
              </tr>
            )}
          </tbody>
          {footer && (
            <tfoot className="table-footer sticky-footer">
              <tr className="bg-gl-success">
                <th  style={{ textAlign: "start" }}>
                  TOTAL
                </th>
                <th colSpan={3} style={{ textAlign: "end" }}>
                  
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(summaryData?.total_buy_qty ?? 0).toLocaleString(
                    "en-IN", {
                       minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                    }
                  )}
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(summaryData?.total_buy_value ?? 0).toLocaleString(
                    "en-IN", {
                       minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                    }
                  )}
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(summaryData?.total_sell_qty ?? 0).toLocaleString(
                    "en-IN", {
                       minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                    }
                  )}
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(
                    summaryData?.total_sell_value ?? 0
                  ).toLocaleString("en-IN", {
                     minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                  })}
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(summaryData?.total_net_qty ?? 0).toLocaleString(
                    "en-IN", {
                       minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                    }
                  )}
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(summaryData?.total_net_value ?? 0).toLocaleString(
                    "en-IN", {
                       minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                    }
                  )}
                </th>
                <th style={{ textAlign: "end" }}>
                  {/* {Number(summaryData?.total_sell_value ?? 0).toLocaleString("en-IN", {
                     minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                  })} */}
                </th>
                <th style={{ textAlign: "end" }}>
                  {/* {Number(summaryData?.total_net_qty ?? 0).toLocaleString("en-IN", {
                     minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                  })} */}
                </th>
                <th style={{ textAlign: "end" }}>
                  {Number(summaryData?.total_pnl ?? 0).toLocaleString(
                    "en-IN", {
                       minimumFractionDigits: 2,
        maximumFractionDigits: 2,
                    }
                  )}
                </th>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </Fragment>
  );
};

export default TableContainerSearch2;
